import styled, { keyframes } from 'styled-components';

const pulse = keyframes`
  0%, 100% {
    opacity: 0.5;
  }
  50% {
    opacity: 1;
  }
`;

export const Container = styled.div<{ $hidden?: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000008;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 101;
  transition: opacity 0.5s ease;
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  pointer-events: ${({ $hidden }) => ($hidden ? 'none' : 'auto')};
`;

export const Text = styled.div`
  width: 100%;
  font-family: 'Adam', sans-serif;
  font-weight: 500;
  color: rgba(255, 200, 100, 0.8);
  font-size: 14px;
  letter-spacing: 5px;
  text-transform: uppercase;
  text-align: center;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

export const Status = styled.div`
  font-family: 'Share Tech Mono', monospace;
  color: rgba(255, 255, 255, 0.5);
  font-size: 11px;
  margin-top: 15px;
  letter-spacing: 2px;
`;

export const ProgressContainer = styled.div`
  width: 200px;
  height: 3px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
  margin-top: 12px;
  overflow: hidden;
`;

export const ProgressBar = styled.div`
  height: 100%;
  width: 0%;
  background: linear-gradient(90deg, rgba(255, 200, 100, 0.8), rgba(255, 150, 50, 1));
  border-radius: 2px;
  transition: width 0.3s ease;
`;

export const Count = styled.div`
  font-family: 'Share Tech Mono', monospace;
  color: rgba(255, 200, 100, 0.6);
  font-size: 12px;
  margin-top: 8px;
`;
